<div class="terms-container">
    <div class="terms">
        <h2>Applicant’s Acknowledgement</h2>
        <p>The acquisition of the certified vehicle inspection and its associated guarantee is an optional procedure and is not mandatory for purchasing an inspection nor obligates the customer to purchase the inspected vehicle. This guarantee constitutes a contract between the service provider and customer.</p>
        <h2>Definitions</h2>
        <p>The following words whether capitalized or in bold have the following meaning throughout this Guarantee.</p>
        <ul>
            <li>Administrator means DealerAdmin.io, LLC, 8940 Fourwinds Drive Suite 610, Windcrest, TX 78239 is the administrator;</li>
            <li>Guarantor, We, Us, Our: the Inspection Company listed in the Inspection Company Information section in the Application Page for the Covered Vehicle listed in the Application Page.</li>
            <li>Service: refers to the vehicle inspection conducted by the Service Provider.</li>
            <li>Guarantee Term: means it begins on the Purchase Date of the Inspection, is for the Term in Months shown on the Application Page, and expires on the Expiration Date.</li>
            <li>Inspected Part: refers to any component of the Customer’s vehicle that was specifically examined during the Service Provider’s inspection process.</li>
            <li>Failure: refers to the malfunction of an Inspected Part due to defects in materials or workmanship that were not identified during the inspection service.</li>
            <li>Powertrain Items: include the engine, transmission, and drive axle of the vehicle.</li>
            <li>Non-Powertrain Items: include all other Inspected Parts not classified as Powertrain Items.</li>
            <li>Vehicle, Inspected Vehicle, Covered Vehicle: the Vehicle which is the subject of the inspection service.</li>
        </ul>
        <h2>Inspection Guarantee</h2>
        <p>We agree to pay the cost of repairs during the Guarantee Term, up to a maximum of five thousand dollars ($5,000) for Powertrain (Engine, Transmission, Drive Axle) related repairs; for any non-powertrain part the maximum coverage is seven hundred fifty ($750) and a limit of two (2) claims for items inspected during the inspection of the Inspected Vehicle, less the deductible. Please note that there are specific exclusions that are not covered under this Guarantee see the list of Exclusions below in the Exclusions Section.</p>
        <div class="benefits-container">
            <div class="benefit-list-column">
                <ul class="benefit-list">
                    <li class="benefits">Cooling System Covered Benefits</li>
                    <li>Radiator</li>
                    <li>Coolant Expansion Tank</li>
                    <li>Cooling Fan Clutch</li>
                    <li>Cooling Fan Motor</li>
                    <li>Vacuum Modulator</li>
                    <li>Heater Core</li>
                    <li>Heater Core Vale</li>
                    <li>Fuel System Covered Benefits</li>
                    <li>Fuel Injector</li>
                    <li>Fuel Injector Seals</li>
                    <li>Fuel Pressure Regulator</li>
                    <li>Fuel Pump Fuel System Diesel Fuel Injector Diesel Fuel Pump Diesel Injection Pump Carburetor</li>
                </ul>
                <ul class="benefit-list">
                    <li class="benefits">Electrical System</li>
                    <li>ECM</li>
                    <li>TCM</li>
                    <li>PCM</li>
                    <li>Alternator</li>
                    <li>Sending Units</li>
                    <li>Gauges</li>
                    <li>Throttle Position Sensor</li>
                    <li>Oxygen Sensor</li>
                    <li>Cooling Fan Relay</li>
                </ul>
                <ul class="benefit-list">
                    <li class="benefits">Engine Covered Benefits</li>
                    <li>Camshaft - Inclusive of Actuator, Position Sensor, & Seal</li>
                    <li>Connecting Rod</li>
                    <li>Crankcase - Crankshaft, Position Sensor, Pulley & Seal</li>
                    <li>Cylinder Head</li>
                    <li>Distributor</li>
                    <li>Engine Overhaul - Control Unit, Temperature Sensor, Cylinder</li>
                    <li>Glow Plug</li>
                    <li>Head Gasket</li>
                    <li>IAC Valve</li>
                    <li>Idle Air Bypass Kit</li>
                    <li>Ignition Coil</li>
                    <li>Ignition Module</li>
                    <li>MAP Sensor</li>
                    <li>Mass Airflow Sensor</li>
                    <li>Oil Cooler, Oil Pan, Oil Pan Gasket. Oil Pressure Sensor, Oil Pump</li>
                    <li>Piston | Pins & Rings</li>
                    <li>Rear Main Seal</li>
                    <li>Supercharger</li>
                    <li>Throttle Body</li>
                    <li>Turbo Hose</li>
                    <li>Turbocharger</li>
                    <li>Vacuum Pump</li>
                    <li>Excess Drivetrain Covered Benefits</li>
                    <li>CV Axle</li>
                    <li>Clutch Master Cylinder</li>
                    <li>Clutch Pilot Bearing</li>
                    <li>Clutch Release Bearing</li>
                    <li>Clutch Slave Cylinder</li>
                    <li>Differential</li>
                    <li>Driveshaft</li>
                    <li>PCM - Powertrain Control Module</li>
                    <li>Transaxle</li>
                    <li>Universal Joint</li>
                </ul>
            </div>
            <div class="benefit-list-column">
                <ul class="benefit-list">
                    <li class="benefits">Suspension & Steering Covered Benefits</li>
                    <li>Ball Joint</li>
                    <li>CV Half Shaft Boot Kit</li>
                    <li>Control Arm</li>
                    <li>Control Arm Bushing</li>
                    <li>Front Coil Spring</li>
                    <li>Shock Absorber (Front & Rear)</li>
                    <li>Inner Tie Rod End</li>
                    <li>Leaf Spring</li>
                    <li>Steering Box</li>
                    <li>Steering Rack & Pinion</li>
                    <li>Power Steering Flush</li>
                    <li>Power Steering Pressure Hose</li>
                    <li>Power Steering Pump</li>
                    <li>Rear Coil Spring</li>
                    <li>Rear Shock Absorber</li>
                    <li>Sway Bar</li>
                    <li>Steering | Column, Intermediate Shaft, Rack & Pinion, Rack Boot & Bushings</li>
                    <li>Strut Bearing</li>
                    <li>Struts</li>
                    <li>Suspension Knuckle</li>
                    <li>Suspension Overhaul</li>
                    <li>Tie Rod End</li>
                </ul>

                <ul class="benefit-list">
                    <li class="benefits">Transmission Covered Benefits</li>
                    <li>Transmission Overhaul</li>
                    <li>Transmission Cooler</li>
                    <li>Transmission Pan Gasket</li>
                    <li>Transmission Pump</li>
                    <li>Transmission Rear Oil Seal</li>
                    <li>Shift Solenoid</li>
                    <li>Torque Converter</li>
                </ul>
                <ul class="benefit-list">
                    <li class="benefits">Exhaust & Emissions Covered Benefits</li>
                    <li>Air Pump</li>
                    <li>Charcoal Canister</li>
                    <li>Exhaust Gas Recirculation (EGR) System Overhaul</li>
                    <li>EGR- Cooler, Position Sensor, Temperature Sensor, Vacuum Solenoid</li>
                    <li>EGR Valve</li>
                    <li>Evaporative Emission Control (EVAP) System</li>
                    <li>Fuel Tank Pressure Sensor</li>
                    <li>Intake Manifold</li>
                    <li>Intake Manifold Control Runner</li>
                    <li>Knock Sensor</li>
                    <li>Secondary Air Injection System</li>
                    <li>Secondary Air Injection Pump</li>
                </ul>
                <ul class="benefit-list">
                    <li class="benefits">HVAC Covered Benefits</li>
                    <li>Air Conditioning Accumulator/Receiver-Drier</li>
                    <li>Air Conditioning Compressor</li>
                    <li>Air Conditioning Condenser</li>
                    <li>Air Conditioning Evaporator</li>
                    <li>Air Conditioning Hose</li>
                    <li>Expansion Valve</li>
                    <li>Heater Blower Motor</li>
                    <li>Heater Blower Motor Resistor</li>
                    <li>Heater Control Valve</li>
                    <li>Heater Core</li>
                    <li>Heating and Air Conditioning Overhaul</li>
                </ul>
            </div>
        </div>

        <h2>Exclusions</h2>
        <p>This Guarantee does not apply to:</p>
        <ul class="numbered">
            <li>Any condition where the stated component fails the inspection process and is noted on the final inspection.</li>
            <li>Any part or component that is not listed as part of this inspection.</li>
            <li>
                Replacement of maintenance items. Spark plugs, glow plugs, PCV valves, PCV system, filters, lubricants, thermostat housing, thermostats, alignments, coolants, batteries, battery cable, fuses, hoses, belts, tires, wheels, wheel covers, tire pressure sensors, light bulbs, sealed beams, light assemblies, LED lighting, lenses, seat belt systems, exhaust systems /catalytic converters, brake rotors, brake drums, brake shoes, brake pads, speakers, cellular phones, upholstery, paint, glass, trim, moldings, weather strip/seals, door handles, lift gate handles, tailgate handles, door
                bushings I bearings, body panels, sheet metal, bumpers, frames, sub-frames, brackets, convertible top assemblies, vinyl top, personal computers, phone systems and pre-heated car systems, rust, corrosion, water intrusion, water damage, water leaks, air leaks, carburetors, manual clutch system, programming, reprogramming, or updating a component that has not mechanically failed. Any equipment not installed by the manufacturer.
            </li>
            <li>Reimbursement for any repair or replacement made without prior authorization from Administrator to Repair Facility. Except for emergency repairs required outside normal business hours of 9:00 am to 5:00 pm CST.</li>
            <li>Any repair for the purpose of correcting engine compression, correcting oil consumption, or the gradual reduction of performance when a mechanical breakdown has not occurred. Valve grinding, valve guides, burnt valves, stuck valves, burnt piston, and/or stuck rings are not covered.</li>
            <li>Damage caused by pre-ignition detonation, pinging, improper/contaminated fuel, excessive fuel conditions, lean fuel conditions, clogged fuel injectors, improper lubricants, or improper engine adjustments. Any mechanical breakdown caused by failure to maintain proper levels of lubrication, lubricant blockage, coolant blockage, lack of lubrication or carbon buildup in cylinders.</li>
            <li>Loss of time, expense, storage charges, loss of use of Vehicle, loss of profits, income, or other consequential damages, including, but not limited to loss or damage or injury to persons or property resulting from mechanical breakdown of any of the covered parts.</li>
            <li>Any repair that has been misdiagnosed by the Repair Facility, any failure that cannot be verified as accurate or is found to be inaccurate, or any failure related to a previous repair.</li>
            <li>Accidental loss or damage, physical damage, collision or upset, falling missiles or objects, fire, theft, larceny, hail, explosion, lightning, earthquake, windstorm, water, flood, malicious mischief, vandalism, riot, civil commotion, negligence, or misuse.</li>
            <li>Any mechanical breakdown caused by rust, residue, electrolysis, or corrosion.</li>
            <li>Nuts, bolts, or fasteners due to mechanical failure.</li>
            <li>Any condition that existed to any component(s) that were not functioning properly at the time the covered Vehicle was delivered to the Purchaser, or prior to the Sale’s Date of this Contract.</li>
            <li>Repairs to seized or damaged parts due to operation without sufficient oil or coolant.</li>
            <li>Engine block and cylinder heads are not covered if damaged by overheating, freezing or warpage.</li>
            <li>Any Vehicle that has been issued a restricted title, including but not limited to: salvage/refundable, salvage theft, assembled, dismantled, scrap, fire, flood, physical damage, saltwater, frame change, motor change, body exchange, junk or parts only, or if said vehicle is declared a "lemon".</li>
            <li>A mechanical breakdown of a covered component/part caused by a Customer’s refusal or failure to perform reasonable repairs recommended by the Inspection Company, Dealer, Repair Facility or Administrator.</li>
            <li>Damage to a non-covered part by a covered part.</li>
            <li>Mechanical breakdown of a Vehicle or component part when Commercial Use is associated with the Vehicle.</li>
            <li>Snow Removal Equipment, and/or Vehicles using Snow Removal Equipment. (unless Snowplow Option is chosen)</li>
            <li>
                Any Vehicle modified or altered by you or with your knowledge from original manufacturer specification not approved by the manufacturer. Any alterations made to Your Vehicle or You are using Your Vehicle in a manner not recommended by the manufacturer including but not limited to: Failure of any custom or add-on part, all frame or suspension modifications, lift kits, (Unless appropriate Lift Kit Option is indicated on Application page), any tire that is not recommended by the original manufacturer, emissions and/or exhaust systems modifications, engine modifications,
                transmission modifications, and/or drive axle modifications. Conversion van components, and conversion vehicle components.
            </li>
            <li>Diagnostic or tear down time when a mechanical breakdown is not covered by the Contract, or shop supplies of any kind. Any cost incurred for disassembly or diagnosis is at Your expense if the inspection determines that the mechanical breakdown was not caused by the failure of a part covered by this Contract.</li>
            <li>Mechanical breakdown or failure costs that should be covered by a manufacturer's warranty, recall, factory bulletin or any other mechanical breakdown coverage. Mechanical breakdown or failure costs that should be covered by the warranty of parts or workmanship on a previously repaired or replaced component.</li>
            <li>Any mechanical breakdown or failure occurring outside of the United States</li>
            <li>Wear & Tear of covered components.</li>
        </ul>
        <h2>Claim Procedures & How To File A Claim</h2>
        <p>
            It is Your responsibility to authorize tear down and diagnosis to the point where damage is visible, and a cause of failure can be determined. It is Your responsibility to protect the Vehicle from further damage when a mechanical failure has occurred. Continued operation of the Vehicle after any mechanical breakdown occurs shall in all cases constitute failure to protect the Vehicle. Failure to protect the Vehicle is not limited to continued operation after mechanical breakdown alone but may constitute other acts of neglect by You. Be prepared to provide evidence that the
            maintenance services have been performed as specified above. Please ensure that all the required documents are included and are clearly legible.
        </p>
        <p>
            Prior authorization by an Administrator’s Claim Examiner is required. Customer’s Repair Facility MUST obtain an authorization number from the Administrator PRIOR to repairing the Vehicle. Repairs not authorized by the Administrator's Claim Examiner WILL NOT be accepted. Have the Repair Facility's technician or service writer call Administrator for verification of coverage and obtain a claim ID number. Administrator will arrange for payment of authorized claim at that time. Administrator can be contacted Monday through Friday at (833) 267-5309 Emergency repairs performed during
            non-business hours MUST be reported the following business day. Reimbursement will be provided, pursuant to the coverage and limits of this section, for covered claims. Administrator reserves the right to determine where repairs shall be made, and to investigate all claims and inspect any Vehicle. Once a claim ID number is obtained and repairs are completed, all repair orders and documentation must be submitted to Administrator within 60 days to be eligible for payment. You can submit claim documents by emailing us at claims@dealeradmin.io or calling (833) 267-5309 Monday through
            Friday 9AM to 5PM CST.
        </p>
        <h2>Cancellation/ Termination/Transfer</h2>
        <p>This Guarantee is not cancellable. This Guarantee can be transferred one time to another owner with a fifty-dollar ($50) transfer fee.</p>
        <h2>General</h2>
        <p>All documents requested by the Administrator must be completely legible, otherwise, the Guarantee will be suspended until legible copies can be obtained.</p>
        <ul class="numbered">
            <li>Guarantee Term - The Guarantee Term is the Months shown on the Application Page in Terms and Conditions Section. The Guarantee begins on the Purchase Date as shown on the Vehicle Guarantee Information Section. The Guarantee ends when the expiration date is reached.</li>
            <li>When And Where You Are Covered - You are covered when this Guarantee is issued to You at time of Vehicle purchase. This Guarantee applies only to loss occurring within the continental United States of America, Alaska, Hawaii and Canada.</li>
            <li>Subrogation - If We pay for a loss, We may require You to assign to Us Your rights of recovery against others. We will not pay for a loss if You impair these rights to recover. Your rights to recover from others may not be waived. LIMITS OF LIABILITY/ LIMIT OF REPAIRS COST You are responsible for any costs over the specified limits and for any non-covered expenses and or parts not covered under this Guarantee.</li>
            <li>How State Law Applies - Any limitations on the duration of implied warranties, disclosed on the face of the guarantee as provided in section 108 of the Act, 15 U.S.C. 2308; Some states do not allow restrictions on how long an implied Guarantee last, or do not allow the exclusion or limitation of incidental or consequential damages, so the above limitation or exclusions may not apply to You. This Guarantee gives You certain legal rights and You may also have other rights, which differ from state to state.</li>
        </ul>
    </div>
</div>

<style>
    .terms-container {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        padding: 40px;
        text-align: left;
    }
    .terms {
        display: flex;
        max-width: 1300px;
        width: 100%;
        flex-direction: column;
        flex-wrap: wrap;
    }
    h2 {
        font-size: 20px;
        padding: 20px 0;
    }
    p {
        padding-bottom: 20px;
    }
    li {
        padding-bottom: 20px;
        list-style-type: disc;
        margin-left: 16px;
    }
    .benefits-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        padding: 20px 0;
        /* font-size: 14px; */
    }

    .benefit-list-column {
        display: flex;
        flex-direction: column;
        width: calc(50% - 10px);
        gap: 20px;
    }
    ul.benefit-list {
        width: 100%;

        display: flex;
        flex-direction: column;
    }
    ul.benefit-list li {
        list-style-type: none;
        margin: 0;
        padding: 5px 10px;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
    }
    .benefits {
        font-weight: 700;
        border-top: 1px solid #000;
    }
    .numbered li {
        list-style-type: number;
        margin-left: 30px;
    }
    @media screen and (max-width: 800px) {
        .benefit-list-column {
            width: 100%;
        }
    }
</style>
